var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '../../utils/styled-components';
var PositionWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 1.25rem;\n  left: 50%;\n  z-index: ", ";\n  width: 100%;\n  max-width: ", ";\n  text-align: center;\n  transform: translate(-50%, 0);\n  pointer-events: none;\n\n  @media (min-width: ", ") {\n    text-align: ", ";\n  }\n"], ["\n  position: fixed;\n  top: 1.25rem;\n  left: 50%;\n  z-index: ", ";\n  width: 100%;\n  max-width: ", ";\n  text-align: center;\n  transform: translate(-50%, 0);\n  pointer-events: none;\n\n  @media (min-width: ", ") {\n    text-align: ", ";\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.scrollup.zIndex;
}, function (_a) {
    var component = _a.theme.component;
    return component.scrollup.maxWidth;
}, function (_a) {
    var theme = _a.theme;
    return theme.global.breakpoints.desktop;
}, function (props) { return props.buttonAlign; });
PositionWrapper.defaultProps = {
    buttonAlign: 'left',
};
export default PositionWrapper;
var templateObject_1;
//# sourceMappingURL=index.js.map